import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { Accordion } from "../../components/accordion/accordion.component";
import "./live-interest-rates.component.scss";
var LiveInterestRates = /** @class */ (function (_super) {
    tslib_1.__extends(LiveInterestRates, _super);
    function LiveInterestRates(element) {
        return _super.call(this, element) || this;
    }
    LiveInterestRates.prototype.init = function () {
        // variables
        this.seniorCitizens = false;
        this.saveUpPreferentialRates = false;
        this.refreshRates = false;
        var _element = this.element;
        // -- Interest rates names -- //
        // 		Rates Codes:
        // •    FlexiAdvantage – 4484
        // •    Term Fixed Deposit – 9280
        // •    Notice Deposit – 4479
        // •    Money Market Select – 4450
        // •    Society Scheme – 9256
        // •    MarketLink – 9257
        // •    PureSave – 9258
        // •    Money Market Call – 4451
        // •    Tax-Free Call – 9273
        // •    Shari’ah Fixed Deposit – 4453
        // •    SaveUp – 4449
        // GET CUSTOM RATES
        var _productId = "";
        if (window.location.href.includes("getCustomCode=4484")) {
            _productId = "4484";
            this.productCode = "4484";
        }
        else if (window.location.href.includes("getCustomCode=9280")) {
            _productId = "9280";
            this.productCode = "9280";
        }
        else if (window.location.href.includes("getCustomCode=4479")) {
            _productId = "4479";
            this.productCode = "4479";
        }
        else if (window.location.href.includes("getCustomCode=4450")) {
            _productId = "4450";
            this.productCode = "4450";
        }
        else if (window.location.href.includes("getCustomCode=9256")) {
            _productId = "9256";
            this.productCode = "9256";
        }
        else if (window.location.href.includes("getCustomCode=9257")) {
            _productId = "9257";
            this.productCode = "9257";
        }
        else if (window.location.href.includes("getCustomCode=9258")) {
            _productId = "9258";
            this.productCode = "9258";
        }
        else if (window.location.href.includes("getCustomCode=4451")) {
            _productId = "4451";
            this.productCode = "4451";
        }
        else if (window.location.href.includes("getCustomCode=9273")) {
            _productId = "9273";
            this.productCode = "9273";
        }
        else if (window.location.href.includes("getCustomCode=4453")) {
            _productId = "4453";
            this.productCode = "4453";
        }
        else if (window.location.href.includes("getCustomCode=4449")) {
            _productId = "4449";
            this.productCode = "4449";
        }
        else {
            _productId = _element.dataset.product;
            this.productCode = _productId ? _productId : "";
        }
        this.refreshRates = window.location.href.includes("refreshRates=true") ? true : false;
        // -- For product SaveUp - 4449 which has comparitive interest rates -- //
        if (this.productCode === "4449") {
            var compareRatesContainers = this.element.querySelectorAll(".live-interest-rates__dynamic-rates--container__compare-rates");
            if (compareRatesContainers) {
                if (compareRatesContainers.length > 0) {
                    compareRatesContainers.forEach(function (compareRatesContainer) {
                        compareRatesContainer.classList.remove("hidden");
                    });
                }
            }
        }
        // -- For product SaveUp - 4449 which has comparitive interest rates -- //
        // inputs
        this.radioSeniorCitizen = Array.from(this.element.querySelectorAll("input[name=senior-citizens]"));
        if (this.radioSeniorCitizen) {
            if (this.radioSeniorCitizen.length > 0) {
                var _checked = this.element.querySelector("input[name=senior-citizens]:checked");
                if (_checked !== null && _checked.value === "YES") {
                    this.seniorCitizens = true;
                }
            }
        }
        // -- For product SaveUp - 4449 which has comparitive interest rates -- //
        this.saveUpInterestRateTypes = Array.from(this.element.querySelectorAll('.content-list-with-category__chips--item'));
        if (this.saveUpInterestRateTypes) {
            if (this.saveUpInterestRateTypes.length > 0) {
                var activeItem = this.element.querySelector(".content-list-with-category__chips--item.active");
                if (activeItem != null && activeItem.id === "preferential") {
                    this.saveUpPreferentialRates = true;
                }
            }
        }
        // -- For product SaveUp - 4449 which has comparitive interest rates -- //
        // display views
        this.displayRatesModal = this.element.closest("div.modal-dialog.modal__dialog");
        this.displayStaticInterestRates = this.element.querySelector(".live-interest-rates__static-rates");
        this.displayStaticInterestRatesText = this.element.querySelector(".live-interest-rates__static-rates--container__text");
        this.displayDynamicInterestRates = this.element.querySelector(".live-interest-rates__dynamic-rates");
        this.displayLoader = this.element.querySelector(".live-interest-rates__loader");
        // results
        this.accordionResults = this.element.querySelector(".live-interest-rates__accordions");
        // display static rates for test purposes
        if (window.location.href.includes("display=static")) {
            this.showView("static");
        }
        else {
            // retrieve data if 'data-display-live-rates' === 'yes'
            if (this.element.getAttribute("data-display-live-rates")) {
                var displayLiveRates = this.element.getAttribute("data-display-live-rates");
                if (displayLiveRates.toLowerCase() === "yes") {
                    this.retrieveData();
                }
                else {
                    this.showView("static");
                }
            }
            else {
                this.showView("static");
            }
        }
    };
    LiveInterestRates.prototype.bindEvents = function () {
        var _this = this;
        if (this.radioSeniorCitizen) {
            if (this.radioSeniorCitizen.length > 0) {
                this.radioSeniorCitizen.map(function (pRadio) {
                    pRadio.addEventListener("click", function (pEvent) {
                        var _target = pEvent.target;
                        if (_target) {
                            switch (_target.value) {
                                case "YES":
                                    _this.seniorCitizens = true;
                                    break;
                                case "NO":
                                    _this.seniorCitizens = false;
                                    break;
                                default:
                                    _this.seniorCitizens = false;
                                    break;
                            }
                        }
                        _this.retrieveData();
                    });
                });
            }
            if (this.saveUpInterestRateTypes) {
                if (this.saveUpInterestRateTypes.length > 0) {
                    this.saveUpInterestRateTypes.map(function (saveUpInterestRateType) {
                        saveUpInterestRateType.addEventListener("click", function (pEvent) {
                            _this.saveUpInterestRateTypes.forEach(function (saveUpInterestRateTypeItem) {
                                saveUpInterestRateTypeItem.classList.remove("active");
                            });
                            var _target = pEvent.currentTarget;
                            if (_target) {
                                _target.classList.add("active");
                                switch (_target.id) {
                                    case "preferential":
                                        _this.saveUpPreferentialRates = true;
                                        break;
                                    default:
                                        _this.saveUpPreferentialRates = false;
                                        break;
                                }
                            }
                            _this.retrieveData();
                        });
                    });
                }
            }
        }
    };
    LiveInterestRates.prototype.retrieveData = function () {
        this.getInterestRates();
    };
    // 		Rates Codes:
    // •    FlexiAdvantage – 4484
    // •    Term Fixed Deposit – 9280
    // •    Notice Deposit – 4479
    // •    Money Market Select – 4450
    // •    Society Scheme – 9256
    // •    MarketLink – 9257
    // •    PureSave – 9258
    // •    Money Market Call – 4451
    // •    Tax-Free Call – 9273
    // •    Shari’ah Fixed Deposit – 4453
    // •    SaveUp – 4449
    LiveInterestRates.prototype.setInterestRatesData = function (productCode, liveRates) {
        if (productCode === "4484") {
            this.setInterestRatesDataFlexiAdvantage(productCode, liveRates);
        }
        else if (productCode === "9280") {
            this.setInterestRatesDataTermFixedDeposit(productCode, liveRates);
        }
        else if (productCode === "4479") {
            this.setInterestRatesDataNoticeDeposit(productCode, liveRates);
        }
        else if (productCode === "4450") {
            this.setInterestRatesDataMoneyMarketSelect(productCode, liveRates);
        }
        else if (productCode === "9256") {
            this.setInterestRatesDataSocietyScheme(productCode, liveRates);
        }
        else if (productCode === "9257") {
            this.setInterestRatesDataMarketLink(productCode, liveRates);
        }
        else if (productCode === "9258") {
            this.setInterestRatesDataPureSave(productCode, liveRates);
        }
        else if (productCode === "4451") {
            this.setInterestRatesDataMoneyMarketCall(productCode, liveRates);
        }
        else if (productCode === "9273") {
            this.setInterestRatesDataTaxFreeCall(productCode, liveRates);
        }
        else if (productCode === "4453") {
            this.setInterestRatesDataShariahFixedDep(productCode, liveRates);
        }
        else if (productCode === "4449") {
            if (this.saveUpPreferentialRates) {
                this.setInterestRatesDataSaveUpPreferential(productCode, liveRates);
            }
            else {
                this.setInterestRatesDataSaveUpNominal(productCode, liveRates);
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataFlexiAdvantage = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "1000.0"
                    // 2: "10000.0"
                    // 3: "100000.0"
                    // 4: "500000.0"
                    // 5: "1000000.0"
                    // 6: "5000000.0"
                    var _1k_10k_1 = [];
                    var _10k_100k_1 = [];
                    var _100k_500k_1 = [];
                    var _500k_1m_1 = [];
                    var _1m_5m_1 = [];
                    var _5m_above_1 = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "1000.0") {
                                _1k_10k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "10000.0") {
                                _10k_100k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_500k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "500000.0") {
                                _500k_1m_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000000.0") {
                                _1m_5m_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "5000000.0") {
                                _5m_above_1.push(pRate);
                            }
                        }
                    });
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_1k_10k_1.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _1k_10k_1, "Balances between R 1 000 - R 9 999");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_10k_100k_1.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _10k_100k_1, "Balances between R 10 000 - R 99 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        if (_100k_500k_1.length > 0) {
                            var _accordion3 = this.createAccordion(productCode, _100k_500k_1, "Balances between R 100 000 - R 499 999");
                            _accordionContainer.appendChild(_accordion3);
                        }
                        if (_500k_1m_1.length > 0) {
                            var _accordion4 = this.createAccordion(productCode, _500k_1m_1, "Balances between R 500 000 - R 999 999");
                            _accordionContainer.appendChild(_accordion4);
                        }
                        if (_1m_5m_1.length > 0) {
                            var _accordion5 = this.createAccordion(productCode, _1m_5m_1, "Balances between R 1 000 000 - R 4 999 999");
                            _accordionContainer.appendChild(_accordion5);
                        }
                        if (_5m_above_1.length > 0) {
                            var _accordion6 = this.createAccordion(productCode, _5m_above_1, "Balances R 5 000 000 and above");
                            _accordionContainer.appendChild(_accordion6);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataTermFixedDeposit = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "0.0"
                    // 2: "10000.0"
                    // 3: "100000.0"
                    // 4: "500000.0"
                    // 5: "1000000.0"
                    // 6: "5000000.0"
                    var _0_10k_1 = [];
                    var _10k_100k_2 = [];
                    var _100k_500k_2 = [];
                    var _500k_1m_2 = [];
                    var _1m_5m_2 = [];
                    var _5m_above_2 = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "0.0") {
                                _0_10k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "10000.0") {
                                _10k_100k_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_500k_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "500000.0") {
                                _500k_1m_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000000.0") {
                                _1m_5m_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "5000000.0") {
                                _5m_above_2.push(pRate);
                            }
                        }
                    });
                    // add months from above 12 months to all rates above 100k
                    if (_100k_500k_2.length > 12) {
                        for (var i = 12; i < _100k_500k_2.length; i++) {
                            _500k_1m_2.push(_100k_500k_2[i]);
                            _1m_5m_2.push(_100k_500k_2[i]);
                            _5m_above_2.push(_100k_500k_2[i]);
                        }
                    }
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_0_10k_1.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _0_10k_1, "Balances below R 10 000");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_10k_100k_2.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _10k_100k_2, "Balances between R 10 000 - R 99 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        if (_100k_500k_2.length > 0) {
                            var _accordion3 = this.createAccordion(productCode, _100k_500k_2, "Balances between R 100 000 - R 499 999");
                            _accordionContainer.appendChild(_accordion3);
                        }
                        if (_500k_1m_2.length > 0) {
                            var _accordion4 = this.createAccordion(productCode, _500k_1m_2, "Balances between R 500 000 - R 999 999");
                            _accordionContainer.appendChild(_accordion4);
                        }
                        if (_1m_5m_2.length > 0) {
                            var _accordion5 = this.createAccordion(productCode, _1m_5m_2, "Balances between R 1 000 000 - R 4 999 999");
                            _accordionContainer.appendChild(_accordion5);
                        }
                        if (_5m_above_2.length > 0) {
                            var _accordion6 = this.createAccordion(productCode, _5m_above_2, "Balances R 5 000 000 and above");
                            _accordionContainer.appendChild(_accordion6);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataNoticeDeposit = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "250.0"
                    // 2: "5000.0"
                    // 3: "20000.0"
                    // 4: "100000.0"
                    // 5: "1000000.0"
                    var _250_5k_1 = [];
                    var _5k_20k_1 = [];
                    var _20k_100k_1 = [];
                    var _100k_1m_1 = [];
                    var _1m_above_1 = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "250.0") {
                                _250_5k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "5000.0") {
                                _5k_20k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "20000.0") {
                                _20k_100k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_1m_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000000.0") {
                                _1m_above_1.push(pRate);
                            }
                        }
                    });
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_250_5k_1.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _250_5k_1, "Balances between R 250 - R 4 999");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_5k_20k_1.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _5k_20k_1, "Balances between R 5 000 - R 19 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        if (_20k_100k_1.length > 0) {
                            var _accordion3 = this.createAccordion(productCode, _20k_100k_1, "Balances between R 20 000 - R 99 999");
                            _accordionContainer.appendChild(_accordion3);
                        }
                        if (_100k_1m_1.length > 0) {
                            var _accordion4 = this.createAccordion(productCode, _100k_1m_1, "Balances between R 100 000 - R 999 999");
                            _accordionContainer.appendChild(_accordion4);
                        }
                        if (_1m_above_1.length > 0) {
                            var _accordion5 = this.createAccordion(productCode, _1m_above_1, "Balances R 1 000 000 and above");
                            _accordionContainer.appendChild(_accordion5);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataMoneyMarketSelect = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "0.0"
                    // 2: "100000.0"
                    // 3: "250000.0"
                    // 4: "500000.0"
                    // 5: "1000000.0"
                    // 6: "5000000.0"
                    // 7: "10000000.0"
                    // 8: "20000000.0"
                    var _0_100k_1 = [{ interest: "0.0" }]; // Custom zero rate
                    var _100k_250k_1 = [];
                    var _250k_500k_1 = [];
                    var _500k_1m = [];
                    var _1m_5m = [];
                    var _5m_10m = [];
                    var _10m_20m = [];
                    var _20m_above = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "0.0") {
                                _0_100k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_250k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "250000.0") {
                                _250k_500k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "500000.0") {
                                // _500k_1m.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000000.0") {
                                // _1m_5m.push(pRate);
                            }
                            else if (pRate.lowerAmount === "5000000.0") {
                                // _5m_10m.push(pRate);
                            }
                            else if (pRate.lowerAmount === "10000000.0") {
                                // _10m_20m.push(pRate);
                            }
                            else if (pRate.lowerAmount === "20000000.0") {
                                // _20m_above.push(pRate);
                            }
                        }
                    });
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_0_100k_1.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _0_100k_1, "Balances between R 0 - R 99 999");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_100k_250k_1.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _100k_250k_1, "Balances between R 100 000 - R 249 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        if (_250k_500k_1.length > 0) {
                            var _accordion3 = this.createAccordion(productCode, _250k_500k_1, "Balances R 250 000 and above");
                            _accordionContainer.appendChild(_accordion3);
                        }
                        if (_500k_1m.length > 0) {
                            var _accordion4 = this.createAccordion(productCode, _500k_1m, "Balances between R 500 000 - R 999 999");
                            _accordionContainer.appendChild(_accordion4);
                        }
                        if (_1m_5m.length > 0) {
                            var _accordion5 = this.createAccordion(productCode, _1m_5m, "Balances between R 1 000 000 - R 4 999 999");
                            _accordionContainer.appendChild(_accordion5);
                        }
                        if (_5m_10m.length > 0) {
                            var _accordion6 = this.createAccordion(productCode, _5m_10m, "Balances between R 5 000 000 - R 9 999 999");
                            _accordionContainer.appendChild(_accordion6);
                        }
                        if (_10m_20m.length > 0) {
                            var _accordion7 = this.createAccordion(productCode, _10m_20m, "Balances between R 10 000 000 - R 19 999 999");
                            _accordionContainer.appendChild(_accordion7);
                        }
                        if (_20m_above.length > 0) {
                            var _accordion8 = this.createAccordion(productCode, _20m_above, "Balances above R 20 000 000");
                            _accordionContainer.appendChild(_accordion8);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataSocietyScheme = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "0.0"
                    // 2: "1000.0"
                    // 3: "10000.0"
                    // 4: "50000.0"
                    // 5: "100000.0"
                    var _0_1k_1 = [];
                    var _1k_10k_2 = [];
                    var _10k_50k_1 = [];
                    var _50k_100k_1 = [];
                    var _100k_above_1 = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "0.0") {
                                _0_1k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000.0") {
                                _1k_10k_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "10000.0") {
                                _10k_50k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "50000.0") {
                                _50k_100k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_above_1.push(pRate);
                            }
                        }
                    });
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_0_1k_1.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _0_1k_1, "Balances between R 0 - R 999");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_1k_10k_2.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _1k_10k_2, "Balances between R 1 000 - R 9 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        if (_10k_50k_1.length > 0) {
                            var _accordion3 = this.createAccordion(productCode, _10k_50k_1, "Balances between R 10 000 - R 49 999");
                            _accordionContainer.appendChild(_accordion3);
                        }
                        if (_50k_100k_1.length > 0) {
                            var _accordion4 = this.createAccordion(productCode, _50k_100k_1, "Balances between R 50 000 - R 99 999");
                            _accordionContainer.appendChild(_accordion4);
                        }
                        if (_100k_above_1.length > 0) {
                            var _accordion5 = this.createAccordion(productCode, _100k_above_1, "Balances R 100 000 and above");
                            _accordionContainer.appendChild(_accordion5);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataMarketLink = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "0.0"
                    // 2: "1000.0"
                    // 3: "5000.0"
                    // 4: "20000.0"
                    // 5: "100000.0"
                    // 6: "1000000.0"
                    var _0_1k_2 = [{ interest: "0.0" }]; // Custom zero rate
                    var _1k_5k_1 = [];
                    var _5k_20k_2 = [];
                    var _20k_100k_2 = [];
                    var _100k_1m_2 = [];
                    var _1m_above_2 = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "0.0") {
                                _0_1k_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000.0") {
                                _1k_5k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "5000.0") {
                                _5k_20k_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "20000.0") {
                                _20k_100k_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_1m_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000000.0") {
                                _1m_above_2.push(pRate);
                            }
                        }
                    });
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_0_1k_2.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _0_1k_2, "Balances between R 0 - R 999");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_1k_5k_1.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _1k_5k_1, "Balances between R 1 000 - R 4 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        if (_5k_20k_2.length > 0) {
                            var _accordion3 = this.createAccordion(productCode, _5k_20k_2, "Balances between R 5 000 - R 19 999");
                            _accordionContainer.appendChild(_accordion3);
                        }
                        if (_20k_100k_2.length > 0) {
                            var _accordion4 = this.createAccordion(productCode, _20k_100k_2, "Balances between R 20 000 - R 99 999");
                            _accordionContainer.appendChild(_accordion4);
                        }
                        if (_100k_1m_2.length > 0) {
                            var _accordion5 = this.createAccordion(productCode, _100k_1m_2, "Balances between R 100 000 - R 999 999");
                            _accordionContainer.appendChild(_accordion5);
                        }
                        if (_1m_above_2.length > 0) {
                            var _accordion6 = this.createAccordion(productCode, _1m_above_2, "Balances R 1 000 000 and above");
                            _accordionContainer.appendChild(_accordion6);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataPureSave = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "0.0"
                    // 2: "1000.0"
                    // 3: "10000.0"
                    // 4: "20000.0"
                    // 5: "100000.0"
                    var _0_1k_3 = [];
                    var _1k_10k_3 = [];
                    var _10k_20k_1 = [];
                    var _20k_100k_3 = [];
                    var _100k_above_2 = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "0.0") {
                                _0_1k_3.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000.0") {
                                _1k_10k_3.push(pRate);
                            }
                            else if (pRate.lowerAmount === "10000.0") {
                                _10k_20k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "20000.0") {
                                _20k_100k_3.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_above_2.push(pRate);
                            }
                        }
                    });
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_0_1k_3.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _0_1k_3, "Balances between R 0 - R 999");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_1k_10k_3.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _1k_10k_3, "Balances between R 1 000 - R 9 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        if (_10k_20k_1.length > 0) {
                            var _accordion3 = this.createAccordion(productCode, _10k_20k_1, "Balances between R 10 000 - R 19 999");
                            _accordionContainer.appendChild(_accordion3);
                        }
                        if (_20k_100k_3.length > 0) {
                            var _accordion4 = this.createAccordion(productCode, _20k_100k_3, "Balances between R 20 000 - R 99 999");
                            _accordionContainer.appendChild(_accordion4);
                        }
                        if (_100k_above_2.length > 0) {
                            var _accordion5 = this.createAccordion(productCode, _100k_above_2, "Balances R 100 000 and above");
                            _accordionContainer.appendChild(_accordion5);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataMoneyMarketCall = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "20000.0"
                    // 2: "100000.0"
                    // 3: "250000.0"
                    // 4: "500000.0"
                    // 5: "1000000.0"
                    // 6: "20000000.0"
                    var _20k_100k_4 = [];
                    var _100k_250k_2 = [];
                    // const _250k_500k = [];
                    // const _500k_1m = [];
                    var _1m_20m_1 = [];
                    var _20m_above_1 = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "20000.0") {
                                _20k_100k_4.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_250k_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "250000.0") {
                                // _250k_500k.push(pRate);
                            }
                            else if (pRate.lowerAmount === "500000.0") {
                                // _500k_1m.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000000.0") {
                                _1m_20m_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "20000000.0") {
                                _20m_above_1.push(pRate);
                            }
                        }
                    });
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_20k_100k_4.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _20k_100k_4, "Balances between R 20 000 - R 99 999");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_100k_250k_2.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _100k_250k_2, "Balances between R 100 000 - R 999 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        // if (_250k_500k.length > 0) {
                        // 	const _accordion3 = this.createAccordion(productCode, _250k_500k, `Balances between R 250 000 - R 499 999`);
                        // 	_accordionContainer.appendChild(_accordion3);
                        // }
                        // if (_500k_1m.length > 0) {
                        // 	const _accordion4 = this.createAccordion(productCode, _500k_1m, `Balances between R 500 000 - R 999 999`);
                        // 	_accordionContainer.appendChild(_accordion4);
                        // }
                        if (_1m_20m_1.length > 0) {
                            var _accordion5 = this.createAccordion(productCode, _1m_20m_1, "Balances between R 1 000 000 - R 19 999 999");
                            _accordionContainer.appendChild(_accordion5);
                        }
                        if (_20m_above_1.length > 0) {
                            var _accordion6 = this.createAccordion(productCode, _20m_above_1, "Balances R 20 000 000 and above");
                            _accordionContainer.appendChild(_accordion6);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataTaxFreeCall = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "0.0"
                    // 2: "250.0"
                    // 3: "15000.0"
                    // 4: "33000.0"
                    // 5: "50000.0"
                    // 6: "100000.0"
                    var _0_250_1 = [{ interest: "0.0" }]; // Custom zero rate
                    var _250_15k_1 = [];
                    var _15k_33k_1 = [];
                    var _33k_50k_1 = [];
                    var _50k_100k_2 = [];
                    var _100k_above_3 = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "0.0") {
                                _0_250_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "250.0") {
                                _250_15k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "15000.0") {
                                _15k_33k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "33000.0") {
                                _33k_50k_1.push(pRate);
                            }
                            else if (pRate.lowerAmount === "50000.0") {
                                _50k_100k_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_above_3.push(pRate);
                            }
                        }
                    });
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_0_250_1.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _0_250_1, "Balances between R 0 - R 249");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_250_15k_1.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _250_15k_1, "Balances between R 250 - R 14 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        if (_15k_33k_1.length > 0) {
                            var _accordion3 = this.createAccordion(productCode, _15k_33k_1, "Balances between R 15 000 - R 32 999");
                            _accordionContainer.appendChild(_accordion3);
                        }
                        if (_33k_50k_1.length > 0) {
                            var _accordion4 = this.createAccordion(productCode, _33k_50k_1, "Balances between R 33 000 - R 49 999");
                            _accordionContainer.appendChild(_accordion4);
                        }
                        if (_50k_100k_2.length > 0) {
                            var _accordion4 = this.createAccordion(productCode, _50k_100k_2, "Balances between R 50 000 - R 99 999");
                            _accordionContainer.appendChild(_accordion4);
                        }
                        if (_100k_above_3.length > 0) {
                            var _accordion5 = this.createAccordion(productCode, _100k_above_3, "Balances R 100 000 and above");
                            _accordionContainer.appendChild(_accordion5);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataShariahFixedDep = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (this.accordionResults) {
                    // -- INTEREST RATES BANDS -- //
                    // 1: "0.0"
                    // 2: "10000.0"
                    // 3: "100000.0"
                    // 4: "500000.0"
                    // 5: "1000000.0"
                    // 6: "5000000.0"
                    var _0_10k_2 = [];
                    var _10k_100k_3 = [];
                    var _100k_500k_3 = [];
                    var _500k_1m_3 = [];
                    var _1m_5m_3 = [];
                    var _5m_above_3 = [];
                    liveRates.map(function (pRate) {
                        if (pRate.lowerAmount) {
                            if (pRate.lowerAmount === "0.0") {
                                _0_10k_2.push(pRate);
                            }
                            else if (pRate.lowerAmount === "10000.0") {
                                _10k_100k_3.push(pRate);
                            }
                            else if (pRate.lowerAmount === "100000.0") {
                                _100k_500k_3.push(pRate);
                            }
                            else if (pRate.lowerAmount === "500000.0") {
                                _500k_1m_3.push(pRate);
                            }
                            else if (pRate.lowerAmount === "1000000.0") {
                                _1m_5m_3.push(pRate);
                            }
                            else if (pRate.lowerAmount === "5000000.0") {
                                _5m_above_3.push(pRate);
                            }
                        }
                    });
                    // add months from above 12 months to all rates above 100k
                    if (_100k_500k_3.length > 12) {
                        for (var i = 12; i < _100k_500k_3.length; i++) {
                            _500k_1m_3.push(_100k_500k_3[i]);
                            _1m_5m_3.push(_100k_500k_3[i]);
                            _5m_above_3.push(_100k_500k_3[i]);
                        }
                    }
                    if (this.accordionResults) {
                        var _accordion = document.createElement("div");
                        _accordion.classList.add("accordion");
                        _accordion.classList.add("accordion--default");
                        _accordion.dataset.component = "accordion";
                        var _accordionContainer = document.createElement("div");
                        _accordionContainer.classList.add("accordion__container");
                        _accordionContainer.classList.add("clearfix");
                        if (_0_10k_2.length > 0) {
                            var _accordion1 = this.createAccordion(productCode, _0_10k_2, "Balances below R 10 000");
                            _accordionContainer.appendChild(_accordion1);
                        }
                        if (_10k_100k_3.length > 0) {
                            var _accordion2 = this.createAccordion(productCode, _10k_100k_3, "Balances between R 10 000 - R 99 999");
                            _accordionContainer.appendChild(_accordion2);
                        }
                        _accordion.appendChild(_accordionContainer);
                        this.accordionResults.innerHTML = "";
                        this.accordionResults.appendChild(_accordion);
                        var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                        var accordionComponent = new Accordion(_accordionDOM);
                        accordionComponent.init();
                        this.showView("dynamic");
                    }
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataSaveUpPreferential = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (liveRates[0]["concessions"] != null && liveRates[0]["concessions"].length > 0) {
                    if (this.accordionResults) {
                        // -- SAVE UP CONCESSIONS INTEREST RATES BANDS -- //
                        // 1: CODE: CONC_MBC01 - "0.0"
                        // 2: CODE: CONC_MBC02 - "1,000.0"
                        // 3: CODE: CONC_MBC03 - "15,000.0"
                        // 4: CODE: CONC_MBC04 - "25,000.0"
                        // 5: CODE: CONC_MBC05 - "50,000.0"
                        // 6: CODE: CONC_MBC06 - "100,000.0"
                        // 7: CODE: CONC_MBC07 - "500,000.0"
                        // 8: CODE: CONC_MBC08 - "1,000,000.0"
                        // 9: CODE: CONC_MBC09 - "5,000,000.0"
                        var _0k_1k_1 = [];
                        var _1k_15k_1 = [];
                        var _15k_25k_1 = [];
                        var _25k_50k_1 = [];
                        var _50k_100k_3 = [];
                        var _100k_500k_4 = [];
                        var _500k_1m_4 = [];
                        var _1m_5m_4 = [];
                        var _5m_above_4 = [];
                        var mainBankedRates = this.getSaveUpMainBankedRatesCalc(liveRates);
                        mainBankedRates.map(function (pRate) {
                            if (pRate.interestReference) {
                                if (pRate.interestReference === "CONC_MBC01") {
                                    _0k_1k_1.push(pRate);
                                }
                                else if (pRate.interestReference === "CONC_MBC02") {
                                    _1k_15k_1.push(pRate);
                                }
                                else if (pRate.interestReference === "CONC_MBC03") {
                                    _15k_25k_1.push(pRate);
                                }
                                else if (pRate.interestReference === "CONC_MBC04") {
                                    _25k_50k_1.push(pRate);
                                }
                                else if (pRate.interestReference === "CONC_MBC05") {
                                    _50k_100k_3.push(pRate);
                                }
                                else if (pRate.interestReference === "CONC_MBC06") {
                                    _100k_500k_4.push(pRate);
                                }
                                else if (pRate.interestReference === "CONC_MBC07") {
                                    _500k_1m_4.push(pRate);
                                }
                                else if (pRate.interestReference === "CONC_MBC08") {
                                    _1m_5m_4.push(pRate);
                                }
                                else if (pRate.interestReference === "CONC_MBC09") {
                                    _5m_above_4.push(pRate);
                                }
                            }
                        });
                        if (this.accordionResults) {
                            var _accordion = document.createElement("div");
                            _accordion.classList.add("accordion");
                            _accordion.classList.add("accordion--default");
                            _accordion.dataset.component = "accordion";
                            var _accordionContainer = document.createElement("div");
                            _accordionContainer.classList.add("accordion__container");
                            _accordionContainer.classList.add("clearfix");
                            if (_0k_1k_1.length > 0) {
                                var _accordion1 = this.createAccordion(productCode, _0k_1k_1, "Balances between R 0.00 - R 999.99");
                                _accordionContainer.appendChild(_accordion1);
                            }
                            if (_1k_15k_1.length > 0) {
                                var _accordion1 = this.createAccordion(productCode, _1k_15k_1, "Balances between R 1,000.00 - R 14,999.99");
                                _accordionContainer.appendChild(_accordion1);
                            }
                            if (_15k_25k_1.length > 0) {
                                var _accordion2 = this.createAccordion(productCode, _15k_25k_1, "Balances between R 15,000.00 - R 24,999.99");
                                _accordionContainer.appendChild(_accordion2);
                            }
                            if (_25k_50k_1.length > 0) {
                                var _accordion3 = this.createAccordion(productCode, _25k_50k_1, "Balances between R 25,000.00 - R 49,999.99");
                                _accordionContainer.appendChild(_accordion3);
                            }
                            if (_50k_100k_3.length > 0) {
                                var _accordion4 = this.createAccordion(productCode, _50k_100k_3, "Balances between R 50,000.00 - R 99,999.99");
                                _accordionContainer.appendChild(_accordion4);
                            }
                            if (_100k_500k_4.length > 0) {
                                var _accordion4 = this.createAccordion(productCode, _100k_500k_4, "Balances between R 100,000.00 - R 499,999.99");
                                _accordionContainer.appendChild(_accordion4);
                            }
                            if (_500k_1m_4.length > 0) {
                                var _accordion4 = this.createAccordion(productCode, _500k_1m_4, "Balances between R 500,000.00 - R 999,999.99");
                                _accordionContainer.appendChild(_accordion4);
                            }
                            if (_1m_5m_4.length > 0) {
                                var _accordion4 = this.createAccordion(productCode, _1m_5m_4, "Balances between R 1,000,000.00 - R 4,999,999.99");
                                _accordionContainer.appendChild(_accordion4);
                            }
                            if (_5m_above_4.length > 0) {
                                var _accordion5 = this.createAccordion(productCode, _5m_above_4, "Balances R 5,000,000.00 and above");
                                _accordionContainer.appendChild(_accordion5);
                            }
                            _accordion.appendChild(_accordionContainer);
                            this.accordionResults.innerHTML = "";
                            this.accordionResults.appendChild(_accordion);
                            var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                            var accordionComponent = new Accordion(_accordionDOM);
                            accordionComponent.init();
                            this.showView("dynamic");
                        }
                    }
                }
                else {
                    this.showView("static");
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    LiveInterestRates.prototype.setInterestRatesDataSaveUpNominal = function (productCode, liveRates) {
        if (liveRates) {
            if (liveRates !== "") {
                if (liveRates[0]["rates"] != null && liveRates[0]["rates"].length > 0) {
                    if (this.accordionResults) {
                        // -- SAVE UP NOMINAL INTEREST RATES BANDS -- //
                        // 1: "0.0"
                        // 2: "1000.0"
                        // 3: "15000.0"
                        // 4: "25000.0"
                        // 5: "50000.0"
                        // 6: "100000.0"
                        // 7: "500000.0"
                        // 8: "1000000.0"
                        // 9: "5000000.0"
                        var _0k_1k_2 = [];
                        var _1k_15k_2 = [];
                        var _15k_25k_2 = [];
                        var _25k_50k_2 = [];
                        var _50k_100k_4 = [];
                        var _100k_500k_5 = [];
                        var _500k_1m_5 = [];
                        var _1m_5m_5 = [];
                        var _5m_above_5 = [];
                        liveRates[0]["rates"].map(function (pRate) {
                            if (pRate.lowerAmount) {
                                if (pRate.lowerAmount === "0.0") {
                                    _0k_1k_2.push(pRate);
                                }
                                else if (pRate.lowerAmount === "1000.0") {
                                    _1k_15k_2.push(pRate);
                                }
                                else if (pRate.lowerAmount === "15000.0") {
                                    _15k_25k_2.push(pRate);
                                }
                                else if (pRate.lowerAmount === "25000.0") {
                                    _25k_50k_2.push(pRate);
                                }
                                else if (pRate.lowerAmount === "50000.0") {
                                    _50k_100k_4.push(pRate);
                                }
                                else if (pRate.lowerAmount === "100000.0") {
                                    _100k_500k_5.push(pRate);
                                }
                                else if (pRate.lowerAmount === "500000.0") {
                                    _500k_1m_5.push(pRate);
                                }
                                else if (pRate.lowerAmount === "1000000.0") {
                                    _1m_5m_5.push(pRate);
                                }
                                else if (pRate.lowerAmount === "5000000.0") {
                                    _5m_above_5.push(pRate);
                                }
                            }
                        });
                        // Add default R0.00 interest rate tier band if no interest rate tier band is found
                        if (_0k_1k_2.length == 0) {
                            _0k_1k_2.push({
                                "productCode": "4449",
                                "lowerAmount": "0.0",
                                "upperAmount": "999.99",
                                "interest": "0.0"
                            });
                        }
                        else if (_0k_1k_2[0].interest == null) {
                            _0k_1k_2[0].interest = "0.0";
                        }
                        if (this.accordionResults) {
                            var _accordion = document.createElement("div");
                            _accordion.classList.add("accordion");
                            _accordion.classList.add("accordion--default");
                            _accordion.dataset.component = "accordion";
                            var _accordionContainer = document.createElement("div");
                            _accordionContainer.classList.add("accordion__container");
                            _accordionContainer.classList.add("clearfix");
                            if (_0k_1k_2.length > 0) {
                                var _accordion1 = this.createAccordion(productCode, _0k_1k_2, "Balances between R 0.00 - R 999.99");
                                _accordionContainer.appendChild(_accordion1);
                            }
                            if (_1k_15k_2.length > 0) {
                                var _accordion1 = this.createAccordion(productCode, _1k_15k_2, "Balances between R 1,000.00 - R 14,999.99");
                                _accordionContainer.appendChild(_accordion1);
                            }
                            if (_15k_25k_2.length > 0) {
                                var _accordion2 = this.createAccordion(productCode, _15k_25k_2, "Balances between R 15,000.00 - R 24,999.99");
                                _accordionContainer.appendChild(_accordion2);
                            }
                            if (_25k_50k_2.length > 0) {
                                var _accordion3 = this.createAccordion(productCode, _25k_50k_2, "Balances between R 25,000.00 - R 49,999.99");
                                _accordionContainer.appendChild(_accordion3);
                            }
                            if (_50k_100k_4.length > 0) {
                                var _accordion4 = this.createAccordion(productCode, _50k_100k_4, "Balances between R 50,000.00 - R 99,999.99");
                                _accordionContainer.appendChild(_accordion4);
                            }
                            if (_100k_500k_5.length > 0) {
                                var _accordion4 = this.createAccordion(productCode, _100k_500k_5, "Balances between R 100,000.00 - R 499,999.99");
                                _accordionContainer.appendChild(_accordion4);
                            }
                            if (_500k_1m_5.length > 0) {
                                var _accordion4 = this.createAccordion(productCode, _500k_1m_5, "Balances between R 500,000.00 - R 999,999.99");
                                _accordionContainer.appendChild(_accordion4);
                            }
                            if (_1m_5m_5.length > 0) {
                                var _accordion4 = this.createAccordion(productCode, _1m_5m_5, "Balances between R 1,000,000.00 - R 4,999,999.99");
                                _accordionContainer.appendChild(_accordion4);
                            }
                            if (_5m_above_5.length > 0) {
                                var _accordion5 = this.createAccordion(productCode, _5m_above_5, "Balances R 5,000,000.00 and above");
                                _accordionContainer.appendChild(_accordion5);
                            }
                            _accordion.appendChild(_accordionContainer);
                            this.accordionResults.innerHTML = "";
                            this.accordionResults.appendChild(_accordion);
                            var _accordionDOM = this.accordionResults.querySelector("div[data-component=\"accordion\"]");
                            var accordionComponent = new Accordion(_accordionDOM);
                            accordionComponent.init();
                            this.showView("dynamic");
                        }
                    }
                }
                else {
                    this.showView("static");
                }
            }
            else {
                this.showView("static");
            }
        }
        else {
            this.showView("static");
        }
    };
    // 		Rates Codes:
    // •    FlexiAdvantage – 4484
    // •    Term Fixed Deposit – 9280
    // •    Notice Deposit – 4479
    // •    Money Market Select – 4450
    // •    Society Scheme – 9256
    // •    MarketLink – 9257
    // •    PureSave – 9258
    // •    Money Market Call – 4451
    // •    Tax-Free Call – 9273
    // •    Shari’ah Fixed Deposit – 4453
    // •    SaveUp – 4449
    LiveInterestRates.prototype.createAccordion = function (productCode, pRates, pAccordionTitle, open) {
        if (open === void 0) { open = false; }
        var _accordionItem = document.createElement("div");
        _accordionItem.classList.add("accordion__items");
        _accordionItem.classList.add("accordion__items--default");
        _accordionItem.dataset.trackingregion =
            "accordion > " + pAccordionTitle;
        var _accordionTitle = document.createElement("div");
        _accordionTitle.classList.add("accordion__item");
        _accordionTitle.classList.add("js-accordion-trigger");
        if (open) {
            _accordionTitle.classList.add("accordion__item--open");
        }
        else {
            _accordionTitle.classList.add("accordion__item--closed");
        }
        _accordionTitle.dataset.id = "link_accordion_accordion";
        _accordionTitle.dataset.text = pAccordionTitle;
        var _accordionTitleText = document.createElement("div");
        _accordionTitleText.classList.add("title");
        _accordionTitleText.classList.add("title--entrance");
        _accordionTitleText.classList.add("accordion__title");
        _accordionTitleText.classList.add("accordion__title--entrance");
        _accordionTitleText.innerText = pAccordionTitle;
        _accordionTitle.appendChild(_accordionTitleText);
        var _accordionContent = document.createElement("div");
        _accordionContent.classList.add("accordion__item-content");
        if (open) {
            _accordionContent.classList.add("accordion__item-content--open");
        }
        else {
            _accordionContent.classList.add("accordion__item-content--closed");
        }
        var _accordionContentInner = document.createElement("div");
        _accordionContentInner.classList.add("accordion__item-content-inner");
        var _accordionContentInnerTable;
        if (productCode === "4484") {
            _accordionContentInnerTable =
                this.createTableFlexiAdvantage(pRates);
        }
        else if (productCode === "9280") {
            _accordionContentInnerTable =
                this.createTableTermFixedDeposit(pRates);
        }
        else if (productCode === "4479") {
            _accordionContentInnerTable = this.createTableNoticeDeposit(pRates);
        }
        else if (productCode === "4450") {
            _accordionContentInnerTable =
                this.createTableMoneyMarketSelect(pRates);
        }
        else if (productCode === "9256") {
            _accordionContentInnerTable = this.createTableSocietyScheme(pRates);
        }
        else if (productCode === "9257") {
            _accordionContentInnerTable = this.createTableMarketLink(pRates);
        }
        else if (productCode === "9258") {
            _accordionContentInnerTable = this.createTablePureSave(pRates);
        }
        else if (productCode === "4451") {
            _accordionContentInnerTable =
                this.createTableMoneyMarketCall(pRates);
        }
        else if (productCode === "9273") {
            _accordionContentInnerTable = this.createTableTaxFreeCall(pRates);
        }
        else if (productCode === "4453") {
            _accordionContentInnerTable =
                this.createTableShariahFixedDep(pRates);
        }
        else if (productCode === "4449") {
            if (this.saveUpPreferentialRates) {
                _accordionContentInnerTable = this.createTableSaveUpPreferential(pRates);
            }
            else {
                _accordionContentInnerTable = this.createTableSaveUpNominal(pRates);
            }
        }
        _accordionContentInner.appendChild(_accordionContentInnerTable);
        _accordionContent.appendChild(_accordionContentInner);
        _accordionItem.appendChild(_accordionTitle);
        _accordionItem.appendChild(_accordionContent);
        return _accordionItem;
    };
    LiveInterestRates.prototype.createTableFlexiAdvantage = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Investment Terms (months)";
        var _tableHeadRowColumn2 = document.createElement("th");
        _tableHeadRowColumn2.innerText = "Nominal Interest Rate*";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        tableHeadRow.appendChild(_tableHeadRowColumn2);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.period) {
                if (pRate.period !== "" &&
                    (pRate.period === "3" ||
                        pRate.period === "6" ||
                        pRate.period === "9" ||
                        pRate.period === "12")) {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText =
                        "" + (pRate.period ? pRate.period : "");
                    var _tableBodyRowColumn2 = document.createElement("td");
                    _tableBodyRowColumn2.innerText = pRate.interest
                        ? pRate.interest + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBodyRow.appendChild(_tableBodyRowColumn2);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        var tableNote = document.createElement("div");
        tableNote.innerHTML = "*Nominal Rate Per Annum (NACM) - The annualised interest rate that you will earn daily and is capitalised monthly.\n\t\t\tThis rate does not take into account interest compounding effect.";
        tableNote.style.padding = "10px";
        _tableWrapperInner.appendChild(tableNote);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableTermFixedDeposit = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Investment Term";
        var _tableHeadRowColumn2 = document.createElement("th");
        _tableHeadRowColumn2.innerText = "Nominal Interest Rate*";
        var _tableHeadRowColumn3 = document.createElement("th");
        _tableHeadRowColumn3.innerText = "Rate at Maturity**";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        tableHeadRow.appendChild(_tableHeadRowColumn2);
        tableHeadRow.appendChild(_tableHeadRowColumn3);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            var _tableBodyRow = document.createElement("tr");
            var _tableBodyRowColumn1 = document.createElement("td");
            _tableBodyRowColumn1.innerText =
                "Month " + (pRate.period ? pRate.period : "");
            var _tableBodyRowColumn2 = document.createElement("td");
            _tableBodyRowColumn2.innerText = pRate.interest
                ? pRate.interest + " %"
                : "";
            var _tableBodyRowColumn3 = document.createElement("td");
            _tableBodyRowColumn3.innerText = pRate.maturityInterest
                ? pRate.maturityInterest + " %"
                : "";
            _tableBodyRow.appendChild(_tableBodyRowColumn1);
            _tableBodyRow.appendChild(_tableBodyRowColumn2);
            _tableBodyRow.appendChild(_tableBodyRowColumn3);
            _tableBody.appendChild(_tableBodyRow);
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        var tableNote = document.createElement("div");
        tableNote.innerHTML = "*Nominal Rate Per Annum (NACM) - The annualised interest rate that you will earn daily and is capitalised monthly.\n\t\t\tThis rate does not take into account interest compounding effect. <br /> ** Rate at Maturity - The interest rate you will be paid at maturity of your Fixed Deposit account, assuming no interest is withdrawn.";
        tableNote.style.padding = "10px";
        _tableWrapperInner.appendChild(tableNote);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableNoticeDeposit = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Notice";
        var _tableHeadRowColumn2 = document.createElement("th");
        _tableHeadRowColumn2.innerText = "Nominal Interest Rate*";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        tableHeadRow.appendChild(_tableHeadRowColumn2);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.period) {
                if (pRate.period !== "" &&
                    (pRate.period === "7" ||
                        pRate.period === "14" ||
                        pRate.period === "21" ||
                        pRate.period === "32" ||
                        pRate.period === "45" ||
                        pRate.period === "60")) {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText =
                        (pRate.period ? pRate.period : "") + " Day Notice";
                    var _tableBodyRowColumn2 = document.createElement("td");
                    _tableBodyRowColumn2.innerText = pRate.interest
                        ? pRate.interest + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBodyRow.appendChild(_tableBodyRowColumn2);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        var tableNote = document.createElement("div");
        tableNote.innerHTML = "*Nominal Rate Per Annum (NACM) - The annualised interest rate that you will earn daily and is capitalised monthly.\n\t\t\tThis rate does not take into account interest compounding effect.";
        tableNote.style.padding = "10px";
        _tableWrapperInner.appendChild(tableNote);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableMoneyMarketSelect = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Nominal interest rates";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.interest) {
                if (pRate.interest !== "") {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText = pRate.interest
                        ? pRate.interest + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableSocietyScheme = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Nominal interest rates";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.interest) {
                if (pRate.interest !== "") {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText = pRate.interest
                        ? pRate.interest + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableMarketLink = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Nominal interest rates";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.interest) {
                if (pRate.interest !== "") {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText = pRate.interest
                        ? pRate.interest + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTablePureSave = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Nominal interest rates";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.interest) {
                if (pRate.interest !== "") {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText = pRate.interest
                        ? pRate.interest + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableMoneyMarketCall = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Nominal interest rates";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.interest) {
                if (pRate.interest !== "") {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText = pRate.interest
                        ? pRate.interest + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableTaxFreeCall = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Nominal interest rates";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.interest) {
                if (pRate.interest !== "") {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText = pRate.interest
                        ? pRate.interest + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableShariahFixedDep = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Interest Period";
        var _tableHeadRowColumn2 = document.createElement("th");
        _tableHeadRowColumn2.innerText = "Interest Monthly";
        var _tableHeadRowColumn3 = document.createElement("th");
        _tableHeadRowColumn3.innerText = "Interest At Maturity";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        tableHeadRow.appendChild(_tableHeadRowColumn2);
        tableHeadRow.appendChild(_tableHeadRowColumn3);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            var _tableBodyRow = document.createElement("tr");
            var _tableBodyRowColumn1 = document.createElement("td");
            _tableBodyRowColumn1.innerText =
                "Month " + (pRate.period ? pRate.period : "");
            var _tableBodyRowColumn2 = document.createElement("td");
            _tableBodyRowColumn2.innerText = pRate.interest
                ? pRate.interest + " %"
                : "";
            var _tableBodyRowColumn3 = document.createElement("td");
            _tableBodyRowColumn3.innerText = pRate.maturityInterest
                ? pRate.maturityInterest + " %"
                : "";
            _tableBodyRow.appendChild(_tableBodyRowColumn1);
            _tableBodyRow.appendChild(_tableBodyRowColumn2);
            _tableBodyRow.appendChild(_tableBodyRowColumn3);
            _tableBody.appendChild(_tableBodyRow);
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableSaveUpPreferential = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Preferential interest rate";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.interestReferencePercentage) {
                if (pRate.interestReferencePercentage !== "") {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText = pRate.interestReferencePercentage
                        ? pRate.interestReferencePercentage + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    LiveInterestRates.prototype.createTableSaveUpNominal = function (pRates) {
        pRates.sort(function (a, b) { return a["period"] - b["period"]; });
        var _tableWrapper = document.createElement("div");
        _tableWrapper.classList.add("table-context");
        var _tableWrapper2 = document.createElement("div");
        _tableWrapper2.classList.add("table-context__wrapper");
        var _tableWrapperInner = document.createElement("div");
        _tableWrapperInner.classList.add("table-context__table");
        var _table = document.createElement("table");
        _table.classList.add("table");
        var _tableHead = document.createElement("thead");
        var tableHeadRow = document.createElement("tr");
        var _tableHeadRowColumn1 = document.createElement("th");
        _tableHeadRowColumn1.innerText = "Nominal interest rate";
        tableHeadRow.appendChild(_tableHeadRowColumn1);
        _tableHead.appendChild(tableHeadRow);
        _table.appendChild(_tableHead);
        var _tableBody = document.createElement("tbody");
        pRates.map(function (pRate) {
            if (pRate.interest) {
                if (pRate.interest !== "") {
                    var _tableBodyRow = document.createElement("tr");
                    var _tableBodyRowColumn1 = document.createElement("td");
                    _tableBodyRowColumn1.innerText = pRate.interest
                        ? Number(pRate.interest).toFixed(2) + " %"
                        : "";
                    _tableBodyRow.appendChild(_tableBodyRowColumn1);
                    _tableBody.appendChild(_tableBodyRow);
                }
            }
        });
        _table.appendChild(_tableBody);
        _tableWrapperInner.appendChild(_table);
        _tableWrapper2.appendChild(_tableWrapperInner);
        _tableWrapper.appendChild(_tableWrapper2);
        return _tableWrapper;
    };
    // 		Rates Codes:
    // •    FlexiAdvantage – 4484
    // •    Term Fixed Deposit – 9280
    // •    Notice Deposit – 4479
    // •    Money Market Select – 4450
    // •    Society Scheme – 9256
    // •    MarketLink – 9257
    // •    PureSave – 9258
    // •    Money Market Call – 4451
    // •    Tax-Free Call – 9273
    // •    Shari’ah Fixed Deposit – 4453
    // •    SaveUp – 4449
    LiveInterestRates.prototype.showView = function (pView) {
        this.displayStaticInterestRates.classList.add("hidden");
        if (this.displayStaticInterestRatesText) {
            this.displayStaticInterestRatesText.classList.add("hidden");
        }
        this.displayDynamicInterestRates.classList.add("hidden");
        this.displayLoader.classList.add("hidden");
        this.accordionResults.classList.add("hidden");
        switch (pView) {
            case "loader":
                this.displayDynamicInterestRates.classList.remove("hidden");
                this.displayLoader.classList.remove("hidden");
                break;
            case "static":
                if (this.displayRatesModal) {
                    if (this.productCode === "4479") {
                        this.displayRatesModal.classList.add("modal__dialog--large");
                        this.displayRatesModal.classList.remove("modal__dialog--x-large");
                        this.displayRatesModal.classList.remove("modal__dialog--medium");
                    }
                    else {
                        this.displayRatesModal.classList.add("modal__dialog--x-large");
                        this.displayRatesModal.classList.remove("modal__dialog--large");
                        this.displayRatesModal.classList.remove("modal__dialog--medium");
                    }
                }
                this.displayStaticInterestRates.classList.remove("hidden");
                if (this.displayStaticInterestRatesText) {
                    this.displayStaticInterestRatesText.classList.add("hidden");
                }
                break;
            case "dynamic":
                if (this.displayRatesModal) {
                    this.displayRatesModal.classList.add("modal__dialog--medium");
                    this.displayRatesModal.classList.remove("modal__dialog--large");
                    this.displayRatesModal.classList.remove("modal__dialog--x-large");
                }
                this.displayDynamicInterestRates.classList.remove("hidden");
                this.accordionResults.classList.remove("hidden");
                break;
        }
    };
    // 		Rates Codes:
    // •    FlexiAdvantage – 4484
    // •    Term Fixed Deposit – 9280
    // •    Notice Deposit – 4479
    // •    Money Market Select – 4450
    // •    Society Scheme – 9256
    // •    MarketLink – 9257
    // •    PureSave – 9258
    // •    Money Market Call – 4451
    // •    Tax-Free Call – 9273
    // •    Shari’ah Fixed Deposit – 4453
    // •    SaveUp – 4449
    LiveInterestRates.prototype.getLiveInterestRates = function (interestRatesName, interestRatesTime) {
        var _this = this;
        if (this.productCode !== "") {
            var _products = {
                productCode: this.productCode,
                seniorCitizen: "",
            };
            if (this.seniorCitizens) {
                _products.seniorCitizen = "true";
            }
            else {
                delete _products.seniorCitizen;
            }
            var _postData = {
                products: [_products],
                originatingSystem: "SBSA WEB",
            };
            var _url_1 = "";
            if (this.productCode === "4449") {
                _url_1 = this.baseUrl + "/pbbsaleads/v1/live-interest-rates/cons-rates";
            }
            else {
                _url_1 = this.baseUrl + "/pbbsaleads/v1/live-interest-rates";
            }
            var _config = {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "X-Requested-With": "XMLHttpRequest",
                    "Analytics-User": this.analyticsService.getDtmVisitorID(),
                },
            };
            this.formsService
                .postForm(_url_1, _postData, _config)
                .then(function (pResults) {
                var _results = pResults.data;
                if (_results) {
                    if (_results.length > 0) {
                        _this.setInterestRatesData(_this.productCode, _results);
                        _this.storeInterestRates(interestRatesName, JSON.stringify(_results), interestRatesTime, 15);
                    }
                    else {
                        _this.showView("static");
                    }
                }
                else {
                    _this.showView("static");
                }
            })
                .catch(function (pError) {
                // service failed
                _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + _url_1);
                _this.showView("static");
            });
        }
    };
    LiveInterestRates.prototype.getInterestRates = function () {
        var _productId = "";
        if (window.location.href.includes("getCustomCode=4484")) {
            _productId = "4484";
        }
        else if (window.location.href.includes("getCustomCode=9280")) {
            _productId = "9280";
        }
        else if (window.location.href.includes("getCustomCode=4479")) {
            _productId = "4479";
        }
        else if (window.location.href.includes("getCustomCode=4450")) {
            _productId = "4450";
        }
        else if (window.location.href.includes("getCustomCode=9256")) {
            _productId = "9256";
        }
        else if (window.location.href.includes("getCustomCode=9257")) {
            _productId = "9257";
        }
        else if (window.location.href.includes("getCustomCode=9258")) {
            _productId = "9258";
        }
        else if (window.location.href.includes("getCustomCode=4451")) {
            _productId = "4451";
        }
        else if (window.location.href.includes("getCustomCode=9273")) {
            _productId = "9273";
        }
        else if (window.location.href.includes("getCustomCode=4453")) {
            _productId = "4453";
        }
        else if (window.location.href.includes("getCustomCode=4449")) {
            _productId = "4449";
        }
        else {
            var _element = this.element;
            _productId = _element.dataset.product;
        }
        // GET STORED RATES
        var interestRatesName = "";
        var interestRatesTime = "";
        if (_productId) {
            if (_productId !== "" && _productId === "4484") {
                interestRatesName = "FlexiAdvantage";
                interestRatesTime = "FlexiAdvantageExpire";
            }
            else if (_productId !== "" && _productId === "9280") {
                interestRatesName = "TermFixedDeposit";
                interestRatesTime = "TermFixedDepositExpire";
            }
            else if (_productId !== "" && _productId === "4479") {
                interestRatesName = "NoticeDeposit";
                interestRatesTime = "NoticeDepositExpire";
            }
            else if (_productId !== "" && _productId === "4450") {
                interestRatesName = "MoneyMarketSelect";
                interestRatesTime = "MoneyMarketSelectExpire";
            }
            else if (_productId !== "" && _productId === "9256") {
                interestRatesName = "SocietyScheme";
                interestRatesTime = "SocietySchemeExpire";
            }
            else if (_productId !== "" && _productId === "9257") {
                interestRatesName = "MarketLink";
                interestRatesTime = "MarketLinkExpire";
            }
            else if (_productId !== "" && _productId === "9258") {
                interestRatesName = "PureSave";
                interestRatesTime = "PureSaveExpire";
            }
            else if (_productId !== "" && _productId === "4451") {
                interestRatesName = "MoneyMarketCall";
                interestRatesTime = "MoneyMarketCallExpire";
            }
            else if (_productId !== "" && _productId === "9273") {
                interestRatesName = "TaxFreeCall";
                interestRatesTime = "TaxFreeCallExpire";
            }
            else if (_productId !== "" && _productId === "4453") {
                interestRatesName = "ShariahFixedDeposit";
                interestRatesTime = "ShariahFixedDepositExpire";
            }
            else if (_productId !== "" && _productId === "4449") {
                interestRatesName = "SaveUp";
                interestRatesTime = "SaveUpExpire";
            }
        }
        this.showView("loader");
        if (this.seniorCitizens) {
            interestRatesName = interestRatesName + "seniorCitizens";
            interestRatesTime = interestRatesTime + "seniorCitizens";
        }
        var retrievedInterestRates = localStorage.getItem(interestRatesName);
        var _interestRatesTime = localStorage.getItem(interestRatesTime);
        if (retrievedInterestRates && _interestRatesTime) {
            if (retrievedInterestRates !== null &&
                retrievedInterestRates !== "" &&
                _interestRatesTime !== "" &&
                _interestRatesTime !== null) {
                var _retrievedInterestRates = JSON.parse(retrievedInterestRates);
                var getInterestRateExpire = Date.parse(_interestRatesTime);
                var currentTime = new Date().getTime();
                if (currentTime >= getInterestRateExpire) {
                    // delete old rates
                    localStorage.removeItem(interestRatesName);
                    // get new rates
                    this.getLiveInterestRates(interestRatesName, interestRatesTime);
                }
                else {
                    if (this.refreshRates) {
                        // delete old rates
                        localStorage.removeItem(interestRatesName);
                        // get new rates
                        this.getLiveInterestRates(interestRatesName, interestRatesTime);
                    }
                    else {
                        this.setInterestRatesData(this.productCode, _retrievedInterestRates);
                    }
                }
            }
            else {
                // get new rates
                this.getLiveInterestRates(interestRatesName, interestRatesTime);
            }
        }
        else {
            // get new rates
            this.getLiveInterestRates(interestRatesName, interestRatesTime);
        }
    };
    LiveInterestRates.prototype.storeInterestRates = function (interestRatesName, interestRatesValue, interestRateExpireName, interstRatesExpireMinutes, seniorCitizen) {
        var dtDateExpire = new Date();
        dtDateExpire.setTime(dtDateExpire.getTime() + interstRatesExpireMinutes * 60 * 1000);
        localStorage.setItem(interestRatesName, interestRatesValue);
        localStorage.setItem(interestRateExpireName, dtDateExpire.toUTCString());
    };
    LiveInterestRates.prototype.getSaveUpMainBankedRatesCalc = function (liveRates) {
        // -- SAVE UP NOMINAL INTEREST RATES BANDS -- //
        // 1: "0.0"
        // 2: "1000.0"
        // 3: "15000.0"
        // 4: "25000.0"
        // 5: "50000.0"
        // 6: "100000.0"
        // 7: "500000.0"
        // 8: "1000000.0"
        // 9: "5000000.0"
        var _0k_1k = [];
        var _1k_15k = [];
        var _15k_25k = [];
        var _25k_50k = [];
        var _50k_100k = [];
        var _100k_500k = [];
        var _500k_1m = [];
        var _1m_5m = [];
        var _5m_above = [];
        liveRates[0]["rates"].map(function (pRate) {
            if (pRate.lowerAmount) {
                if (pRate.lowerAmount === "0.0") {
                    _0k_1k.push(pRate);
                }
                else if (pRate.lowerAmount === "1000.0") {
                    _1k_15k.push(pRate);
                }
                else if (pRate.lowerAmount === "15000.0") {
                    _15k_25k.push(pRate);
                }
                else if (pRate.lowerAmount === "25000.0") {
                    _25k_50k.push(pRate);
                }
                else if (pRate.lowerAmount === "50000.0") {
                    _50k_100k.push(pRate);
                }
                else if (pRate.lowerAmount === "100000.0") {
                    _100k_500k.push(pRate);
                }
                else if (pRate.lowerAmount === "500000.0") {
                    _500k_1m.push(pRate);
                }
                else if (pRate.lowerAmount === "1000000.0") {
                    _1m_5m.push(pRate);
                }
                else if (pRate.lowerAmount === "5000000.0") {
                    _5m_above.push(pRate);
                }
            }
        });
        // Add default R0.00 interest rate tier band if no interest rate tier band is found
        if (_0k_1k.length == 0) {
            _0k_1k.push({
                "productCode": "4449",
                "lowerAmount": "0.0",
                "upperAmount": "999.99",
                "interest": "0.0"
            });
        }
        else if (_0k_1k[0].interest == null) {
            _0k_1k[0].interest = "0.0";
        }
        // -- SAVE UP CONCESSIONS INTEREST RATES BANDS -- //
        // 1: CODE: CONC_MBC01 - "0.0"
        // 2: CODE: CONC_MBC02 - "1,000.0"
        // 3: CODE: CONC_MBC03 - "15,000.0"
        // 4: CODE: CONC_MBC04 - "25,000.0"
        // 5: CODE: CONC_MBC05 - "50,000.0"
        // 6: CODE: CONC_MBC06 - "100,000.0"
        // 7: CODE: CONC_MBC07 - "500,000.0"
        // 8: CODE: CONC_MBC08 - "1,000,000.0"
        // 9: CODE: CONC_MBC09 - "5,000,000.0"
        var concession_0k_1k = [];
        var concession_1k_15k = [];
        var concession_15k_25k = [];
        var concession_25k_50k = [];
        var concession_50k_100k = [];
        var concession_100k_500k = [];
        var concession_500k_1m = [];
        var concession_1m_5m = [];
        var concession_5m_above = [];
        liveRates[0]["concessions"].map(function (pRate) {
            if (pRate.interestReference) {
                if (pRate.interestReference === "CONC_MBC01") {
                    concession_0k_1k.push(pRate);
                }
                else if (pRate.interestReference === "CONC_MBC02") {
                    concession_1k_15k.push(pRate);
                }
                else if (pRate.interestReference === "CONC_MBC03") {
                    concession_15k_25k.push(pRate);
                }
                else if (pRate.interestReference === "CONC_MBC04") {
                    concession_25k_50k.push(pRate);
                }
                else if (pRate.interestReference === "CONC_MBC05") {
                    concession_50k_100k.push(pRate);
                }
                else if (pRate.interestReference === "CONC_MBC06") {
                    concession_100k_500k.push(pRate);
                }
                else if (pRate.interestReference === "CONC_MBC07") {
                    concession_500k_1m.push(pRate);
                }
                else if (pRate.interestReference === "CONC_MBC08") {
                    concession_1m_5m.push(pRate);
                }
                else if (pRate.interestReference === "CONC_MBC09") {
                    concession_5m_above.push(pRate);
                }
            }
        });
        var mainBankedRates = [];
        mainBankedRates.push({
            "itemCode": concession_0k_1k[0].itemCode,
            "interestReference": concession_0k_1k[0].interestReference,
            "interestReferencePercentage": (Number(_0k_1k[0].interest) + Number(concession_0k_1k[0].interestReferencePercentage)).toFixed(2)
        });
        mainBankedRates.push({
            "itemCode": concession_1k_15k[0].itemCode,
            "interestReference": concession_1k_15k[0].interestReference,
            "interestReferencePercentage": (Number(_1k_15k[0].interest) + Number(concession_1k_15k[0].interestReferencePercentage)).toFixed(2)
        });
        mainBankedRates.push({
            "itemCode": concession_15k_25k[0].itemCode,
            "interestReference": concession_15k_25k[0].interestReference,
            "interestReferencePercentage": (Number(_15k_25k[0].interest) + Number(concession_15k_25k[0].interestReferencePercentage)).toFixed(2)
        });
        mainBankedRates.push({
            "itemCode": concession_25k_50k[0].itemCode,
            "interestReference": concession_25k_50k[0].interestReference,
            "interestReferencePercentage": (Number(_25k_50k[0].interest) + Number(concession_25k_50k[0].interestReferencePercentage)).toFixed(2)
        });
        mainBankedRates.push({
            "itemCode": concession_50k_100k[0].itemCode,
            "interestReference": concession_50k_100k[0].interestReference,
            "interestReferencePercentage": (Number(_50k_100k[0].interest) + Number(concession_50k_100k[0].interestReferencePercentage)).toFixed(2)
        });
        mainBankedRates.push({
            "itemCode": concession_100k_500k[0].itemCode,
            "interestReference": concession_100k_500k[0].interestReference,
            "interestReferencePercentage": (Number(_100k_500k[0].interest) + Number(concession_100k_500k[0].interestReferencePercentage)).toFixed(2)
        });
        mainBankedRates.push({
            "itemCode": concession_500k_1m[0].itemCode,
            "interestReference": concession_500k_1m[0].interestReference,
            "interestReferencePercentage": (Number(_500k_1m[0].interest) + Number(concession_500k_1m[0].interestReferencePercentage)).toFixed(2)
        });
        mainBankedRates.push({
            "itemCode": concession_1m_5m[0].itemCode,
            "interestReference": concession_1m_5m[0].interestReference,
            "interestReferencePercentage": (Number(_1m_5m[0].interest) + Number(concession_1m_5m[0].interestReferencePercentage)).toFixed(2)
        });
        mainBankedRates.push({
            "itemCode": concession_5m_above[0].itemCode,
            "interestReference": concession_5m_above[0].interestReference,
            "interestReferencePercentage": (Number(_5m_above[0].interest) + Number(concession_5m_above[0].interestReferencePercentage)).toFixed(2)
        });
        return mainBankedRates;
    };
    return LiveInterestRates;
}(Base));
export { LiveInterestRates };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/live-interest-rates/live-interest-rates.component.ts
// module id = 986
// module chunks = 0